import React from "react";

export default function Training() {
	return <div>Training</div>;
}
